// components/Footer.jsx

export default function Footer() {
    const currentYear = new Date().getFullYear();
  
    return (
      <footer className="bg-[#0f172a] border-t border-gray-700 w-300">
        <div className="max-w-7xl mx-auto py-8 px-6 lg:px-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-6">
            {/* Copyright Notice */}
            <p className="text-sm text-gray-400 order-2 md:order-1">
              &copy; {currentYear} MNR Technologies Global Pvt Ltd. All Rights Reserved.
            </p>
  
            {/* Legal Links using standard <a> tags */}
            <nav className="flex flex-wrap justify-center gap-x-6 gap-y-2 order-1 md:order-2">
              <a href="/cancel-refund?from=main" className="text-sm text-gray-300 hover:text-blue-800 transition-colors duration-300">
                  Cancellation & Refund
              </a>
              <a href="/terms-service?from=main" className="text-sm text-gray-300 hover:text-blue-800  transition-colors duration-300">
                  Terms of Service
              </a>
              <a href="/privacy-policy?from=main" className="text-sm text-gray-300 hover:text-blue-800  transition-colors duration-300">
                  Privacy Policy
              </a>
            </nav>
          </div>
        </div>
      </footer>
    );
  }